import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3977b7c0")

_pushScopeId("data-v-3977b7c0")
const _hoisted_1 = {
  id: "order-details-title",
  class: "order-details-title text-c"
}
const _hoisted_2 = { class: "product" }
const _hoisted_3 = {
  id: "order-details-title-client",
  class: "client"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "total" }
const _hoisted_6 = { class: "order-actions position-relative px-lg-5" }
const _hoisted_7 = { class: "first" }
const _hoisted_8 = { class: "button-container" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "action-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-f icon-action-cancel fs-26" })
], -1)
const _hoisted_10 = { class: "action-text" }
const _hoisted_11 = { class: "order-info mx-auto row" }
const _hoisted_12 = { class: "info-row col-lg-4" }
const _hoisted_13 = { class: "order-mobile-row" }
const _hoisted_14 = { class: "info-row col-lg-8" }
const _hoisted_15 = { class: "single-ellipsis" }
const _hoisted_16 = { class: "info-row col-lg-4" }
const _hoisted_17 = { class: "white-space-nowrap" }
const _hoisted_18 = { class: "info-row col-lg-4" }
const _hoisted_19 = { class: "info-row col-lg-4" }
const _hoisted_20 = {
  key: 0,
  class: "info-row col-lg-4"
}
const _hoisted_21 = {
  style: {"margin-top":"20px"},
  class: "cost-block d-lg-flex"
}
const _hoisted_22 = { class: "cost-block-row" }
const _hoisted_23 = { class: "label-style" }
const _hoisted_24 = { class: "label-item-style" }
const _hoisted_25 = { class: "cost-block-row" }
const _hoisted_26 = { class: "label-style" }
const _hoisted_27 = { class: "label-item-style" }
const _hoisted_28 = { class: "cost-block-row" }
const _hoisted_29 = { class: "label-style" }
const _hoisted_30 = { class: "label-item-style" }
const _hoisted_31 = { class: "cost-block-row" }
const _hoisted_32 = { class: "label-style" }
const _hoisted_33 = { class: "label-item-style" }
const _hoisted_34 = { class: "order-discountAmount" }
const _hoisted_35 = { class: "cost-block-row" }
const _hoisted_36 = { class: "label-style" }
const _hoisted_37 = { class: "label-item-style" }
const _hoisted_38 = { class: "cost-block-row" }
const _hoisted_39 = { class: "label-style" }
const _hoisted_40 = { class: "label-item-style" }
const _hoisted_41 = { class: "cost-block-row" }
const _hoisted_42 = { class: "label-style" }
const _hoisted_43 = { class: "label-item-style" }
const _hoisted_44 = { class: "price-to-customer" }
const _hoisted_45 = { class: "remarks-block row" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "orderline" }, null, -1)
const _hoisted_47 = { class: "col-lg-12 col-6" }
const _hoisted_48 = { class: "remarks-title" }
const _hoisted_49 = {
  key: 0,
  class: "order-remarks"
}
const _hoisted_50 = { class: "edit-order-remarks-pencil" }
const _hoisted_51 = {
  key: 1,
  class: "col-lg-12 col-6"
}
const _hoisted_52 = { class: "add-order-remarks" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "orderline" }, null, -1)
const _hoisted_54 = { class: "products-block" }
const _hoisted_55 = { class: "title-with-val col-12 col-lg-6" }
const _hoisted_56 = { class: "title" }
const _hoisted_57 = { class: "val" }
const _hoisted_58 = { class: "title-with-val col-12 col-lg-6" }
const _hoisted_59 = { class: "title" }
const _hoisted_60 = { class: "val" }
const _hoisted_61 = { class: "title-with-val col-12 col-lg-6" }
const _hoisted_62 = { class: "title" }
const _hoisted_63 = { class: "val" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "title-with-val col-12 col-lg-6" }
const _hoisted_66 = { class: "title" }
const _hoisted_67 = { class: "val" }
const _hoisted_68 = {
  key: 0,
  class: "product-details title-with-val col-12 pt-4"
}
const _hoisted_69 = { class: "product-details-header" }
const _hoisted_70 = { style: {"width":"30%"} }
const _hoisted_71 = { style: {"width":"20%"} }
const _hoisted_72 = { style: {"width":"13%"} }
const _hoisted_73 = { style: {"width":"13%"} }
const _hoisted_74 = { style: {"width":"15%"} }
const _hoisted_75 = { style: {"width":"30%"} }
const _hoisted_76 = { style: {"width":"20%"} }
const _hoisted_77 = { style: {"width":"13%"} }
const _hoisted_78 = { style: {"width":"13%"} }
const _hoisted_79 = { style: {"width":"15%"} }
const _hoisted_80 = {
  key: 0,
  style: {"padding":"15px 0"}
}
const _hoisted_81 = {
  class: "product-details-header",
  style: {"width":"100%"}
}
const _hoisted_82 = {
  class: "product-details-row",
  style: {"width":"100%"}
}
const _hoisted_83 = {
  class: "product-details-header",
  style: {"width":"100%"}
}
const _hoisted_84 = {
  class: "product-details-row",
  style: {"width":"100%"}
}
const _hoisted_85 = {
  class: "product-details-header",
  style: {"width":"100%"}
}
const _hoisted_86 = {
  class: "product-details-row",
  style: {"width":"100%"}
}
const _hoisted_87 = {
  key: 1,
  class: "order-product-change-date col-12"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "orderline mb-3" }, null, -1)
const _hoisted_89 = { class: "chat-block" }
const _hoisted_90 = { class: "messages-block-header" }
const _hoisted_91 = { class: "messages-block-title" }
const _hoisted_92 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-chat" }, null, -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-settings" }, null, -1)
const _hoisted_94 = { class: "messages-block-info" }
const _hoisted_95 = { class: "messages-block-container" }
const _hoisted_96 = { class: "msg-title" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { key: 2 }
const _hoisted_100 = { class: "msg-text-block" }
const _hoisted_101 = {
  key: 0,
  class: "msg-text"
}
const _hoisted_102 = {
  key: 1,
  class: "msg-text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    (_ctx.isActionsExpand)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["actions-background", { 'backdrop-blur': _ctx.actionsMenu == 'mobile' }],
          onClick: _cache[1] || (_cache[1] = 
        () => {
          _ctx.isActionsExpand = false;
        }
      )
        }, null, 2))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ["container order-details regular-container", { 'display-none': _ctx.actionsMenu == 'mobile' && _ctx.isActionsExpand }],
      id: "order-details"
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.order.orderProducts[0].productName), 1),
        _createVNode("div", _hoisted_3, [
          (_ctx.order.leadCustomer?.name)
            ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.order.leadCustomer.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formatAmount(_ctx.order.priceTotal)) + " " + _toDisplayString(_ctx.order.currencySign), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('orders.orderNumber')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.order.orderNumber || 0), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", {
            class: "action-btn with-word-spacing action-black",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelOrder && _ctx.cancelOrder(...args)))
          }, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('orderActions.cancelOrder')), 1)
          ])
        ]),
        _createVNode("div", {
          class: "status",
          style: { color: _ctx.OrderStatusColors[_ctx.order.statusId] }
        }, _toDisplayString(_ctx.order.status), 5)
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('orders.mobile')) + ":", 1),
          _createVNode("div", _hoisted_13, [
            _createVNode("a", {
              href: 'tel:' + _ctx.order.leadCustomer?.mobile ?? ''
            }, _toDisplayString(_ctx.order.leadCustomer?.mobile ?? ''), 9, ["href"])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('newOrder.email')) + ":", 1),
          _createVNode("div", _hoisted_15, [
            _createVNode("a", {
              class: "mailto",
              href: 'mailto:' + _ctx.order.leadCustomer?.email ?? ''
            }, _toDisplayString(_ctx.order.leadCustomer?.email ?? ''), 9, ["href"])
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('orders.createDate')) + ":", 1),
          _createVNode("div", _hoisted_17, _toDisplayString(_ctx.formatDateIgnoreZone(_ctx.order.createDate)) + " " + _toDisplayString(_ctx.formatTimeIgnoreZone(_ctx.order.createDate.split('T')[1])), 1)
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('product.channel')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.order.channelName ?? ''), 1)
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", null, _toDisplayString(_ctx.$t('product.price-type')) + ":", 1),
          _createVNode("div", null, _toDisplayString(_ctx.order.priceTypeName), 1)
        ]),
        (_ctx.order.affiliateName)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _createVNode("div", null, _toDisplayString(_ctx.$t('label.affiliate-client')) + ":", 1),
              _createVNode("div", null, _toDisplayString(_ctx.order.affiliateName), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_21, [
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('newOrder.gross')) + ":", 1),
          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.formatAmount(_ctx.order.priceTotalWithoutDiscount)) + " " + _toDisplayString(_ctx.order.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('newOrder.commission')) + ":", 1),
          _createVNode("div", _hoisted_27, _toDisplayString(_ctx.formatAmount(_ctx.order.commissionPercent)) + " %", 1)
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('newOrder.net')) + ":", 1),
          _createVNode("div", _hoisted_30, _toDisplayString(_ctx.formatAmount(_ctx.order.priceTotalWithoutDiscount - _ctx.order.commissionTotal)) + " " + _toDisplayString(_ctx.order.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('newOrder.discount')) + ":", 1),
          _createVNode("div", _hoisted_33, [
            _createTextVNode(_toDisplayString(_ctx.order.discountPercent) + "%", 1),
            _createVNode("span", _hoisted_34, "(" + _toDisplayString(_ctx.order.discountAmount.toFixed(2)) + _toDisplayString(_ctx.order.currencySign) + ")", 1)
          ])
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('newOrder.total-pay')), 1),
          _createVNode("div", _hoisted_37, _toDisplayString(_ctx.getOrderTotalToPay.toFixed(2)) + " " + _toDisplayString(_ctx.order.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_38, [
          _createVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('newOrder.paid')), 1),
          _createVNode("div", _hoisted_40, _toDisplayString(_ctx.order.receiptTotal.toFixed(2)) + " " + _toDisplayString(_ctx.order.currencySign), 1)
        ]),
        _createVNode("div", _hoisted_41, [
          _createVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('newOrder.balance')), 1),
          _createVNode("div", _hoisted_43, _toDisplayString((_ctx.getOrderTotalToPay - _ctx.order.receiptTotal).toFixed(2)) + " " + _toDisplayString(_ctx.order.currencySign), 1)
        ])
      ]),
      _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('order.price-to-customer', [_ctx.order.priceTotal, _ctx.order.currencySign])), 1),
      _createVNode("div", _hoisted_45, [
        _hoisted_46,
        _createVNode("div", _hoisted_47, [
          _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('order.remarks')), 1)
        ]),
        (_ctx.order.remarks)
          ? (_openBlock(), _createBlock("div", _hoisted_49, [
              _createVNode("div", _hoisted_50, [
                _createVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeRemarks())),
                  class: "icon-f icon-pencil-edit fs-20"
                })
              ]),
              _createVNode("span", null, _toDisplayString(_ctx.order.remarks), 1)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _createVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeRemarks())),
                  type: "button"
                }, _toDisplayString(_ctx.$t('order.addRemark')), 1)
              ])
            ]))
      ]),
      _hoisted_53,
      _createVNode("div", _hoisted_54, [
        _createVNode("p", null, _toDisplayString(_ctx.$t('newOrder.products')), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.orderProducts, (product, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "product-item mx-auto row px-2 px-lg-0"
          }, [
            _createVNode("div", _hoisted_55, [
              _createVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('newOrder.product')) + ":", 1),
              _createVNode("span", _hoisted_57, _toDisplayString(product.productName), 1)
            ]),
            _createVNode("div", _hoisted_58, [
              _createVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('newOrder.arrivalDate')) + ":", 1),
              _createVNode("span", _hoisted_60, _toDisplayString(_ctx.formatDate(product.date)) + " - " + _toDisplayString(_ctx.formatTime(product.slot.startTime)) + " " + _toDisplayString(_ctx.getHoursMinutesSlotDuration(product.slot.duration)), 1)
            ]),
            _createVNode("div", _hoisted_61, [
              _createVNode("span", _hoisted_62, _toDisplayString(_ctx.$t('existingOrder.QTY')) + ":", 1),
              _createVNode("span", _hoisted_63, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(product.customers, (customer, index) => {
                  return (_openBlock(), _createBlock("div", {
                    style: {"display":"inline-block"},
                    key: index
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(customer.quantity) + " " + _toDisplayString(customer.name) + " ", 1),
                      (index != product.customers.length - 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_64, ", "))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createVNode("div", _hoisted_65, [
              _createVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('newOrder.total')) + ":", 1),
              _createVNode("span", _hoisted_67, _toDisplayString(_ctx.formatAmount(product.price)) + " " + _toDisplayString(_ctx.order.currencySign), 1)
            ]),
            (product.opened)
              ? (_openBlock(), _createBlock("div", _hoisted_68, [
                  _createVNode("div", _hoisted_69, [
                    _createVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('customerType.customerType')) + ":", 1),
                    _createVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('newOrder.perUnit')) + ":", 1),
                    _createVNode("div", _hoisted_72, _toDisplayString(_ctx.$t('existingOrder.QTY')) + ":", 1),
                    _createVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('label.discount')), 1),
                    _createVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('priceList.price')) + ":", 1)
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(product.customers, (customerItem, rowNum) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "product-details-row",
                      key: rowNum
                    }, [
                      _createVNode("div", _hoisted_75, _toDisplayString(customerItem.name), 1),
                      _createVNode("div", _hoisted_76, _toDisplayString(_ctx.formatAmount(customerItem.priceForOne)) + _toDisplayString(_ctx.order.currencySign), 1),
                      _createVNode("div", _hoisted_77, _toDisplayString(customerItem.quantity), 1),
                      _createVNode("div", _hoisted_78, _toDisplayString(customerItem.discountAmount) + _toDisplayString(_ctx.order.currencySign), 1),
                      _createVNode("div", _hoisted_79, _toDisplayString(_ctx.formatAmount(customerItem.price)) + _toDisplayString(_ctx.order.currencySign), 1)
                    ]))
                  }), 128)),
                  (product.covidInfo || product.arrivalInstructions || product.parkingInstructions)
                    ? (_openBlock(), _createBlock("div", _hoisted_80, [
                        (product.covidInfo)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('product-info.title.covid19')) + ":", 1),
                              _createVNode("div", _hoisted_82, _toDisplayString(product.covidInfo), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (product.arrivalInstructions)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              _createVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('address.arrival.instructions')) + ":", 1),
                              _createVNode("div", _hoisted_84, _toDisplayString(product.arrivalInstructions), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (product.parkingInstructions)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                              _createVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('address.parking.instructions')) + ":", 1),
                              _createVNode("div", _hoisted_86, _toDisplayString(product.parkingInstructions), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              onClick: ($event: any) => (product.opened = !product.opened),
              class: "more-product-info d-none d-md-inline"
            }, _toDisplayString(product.opened ? _ctx.$t('button.lessInfo') : _ctx.$t('button.moreInfo')), 9, ["onClick"]),
            false
              ? (_openBlock(), _createBlock("div", _hoisted_87, [
                  _createVNode("i", {
                    onClick: ($event: any) => (_ctx.changeOrderProductDate(product.id)),
                    class: "icon-f icon-pencil-edit fs-16"
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _hoisted_88,
      _createVNode("div", _hoisted_89, [
        _createVNode("div", _hoisted_90, [
          _createVNode("p", _hoisted_91, _toDisplayString(_ctx.$t('orders.messages')), 1),
          _createVNode("button", {
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeChatType('CHAT'))),
            class: ["circle-button btn-blue btn-48 flex-center mx-1", { checked: _ctx.filterType == 'CHAT' }]
          }, [
            _hoisted_92
          ], 2),
          _createVNode("button", {
            type: "button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeChatType('SYSTEM'))),
            class: ["circle-button btn-blue btn-48 flex-center mx-2", { checked: _ctx.filterType == 'SYSTEM' }]
          }, [
            _hoisted_93
          ], 2),
          _createVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeChatType('ALL'))),
            class: ["circle-button btn-blue btn-48 flex-center mx-1", { checked: _ctx.filterType == 'ALL' }]
          }, " All ", 2)
        ]),
        _createVNode("div", _hoisted_94, [
          _createVNode("div", _hoisted_95, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.order.messages, (row) => {
              return (_openBlock(), _createBlock("div", {
                class: ["message-item", 
                row.isMe ? 'from-me' : row.type == 1 ? 'from-system' : row.type == 3 ? 'from-customer' : 'from-user'
              ],
                key: row.id
              }, [
                _createVNode("div", _hoisted_96, [
                  (row.type == 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_97, "System" + _toDisplayString(row.from ? ` (${row.from}),` : ','), 1))
                    : (row.type == 2)
                      ? (_openBlock(), _createBlock("span", _hoisted_98, _toDisplayString(row.from) + ",", 1))
                      : (row.type == 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_99, "Customer,"))
                        : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatChatDate(row.createDate)), 1)
                ]),
                _createVNode("div", _hoisted_100, [
                  (row.type == 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_101, _toDisplayString(_ctx.$t(row.message)), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_102, _toDisplayString(row.message), 1))
                ])
              ], 2))
            }), 128))
          ])
        ])
      ])
    ], 2)
  ]))
})